import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const PekerjaanService = {}

PekerjaanService.getDataAll = function (token) {

    return fetch({
        url: '/ref/pekerjaan',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PekerjaanService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/pekerjaan',
        method: 'get',
        params: {
            "id_pekerjaan":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default PekerjaanService;
